import Axios from "axios";
import { GET_PAYROLL_EARNINGS_CODES, SET_ERROR } from "../../types";

export const getEarningsCodes = (companyId) => async (dispatch) => {

    await Axios.post(`api/earning-codes/get-earning-codes-by-company/${companyId}`).then((response) => {



        dispatch({
            type: GET_PAYROLL_EARNINGS_CODES,
            // payload: response.data.items,
            payload: response.data.data,
        });



    }).catch(e => {
        dispatch({
            type: SET_ERROR,
            payload: {
                e,
                error: true
            }
        })
    });
};
